import { message, Upload } from "antd";

export const DOCUMENT_AND_IMAGE_EXTENSIONS = [
  ".pdf",
  ".doc",
  ".docx",
  ".txt",
  ".rtf",
  ".xls",
  ".xlsx",
  ".csv",
  ".ods",
  ".jpg",
  ".jpeg",
  ".png",
  ".gif",
  ".webp",
  ".heic",
];

export const DOCUMENT_AND_IMAGE_MIME_TYPES = [
  "application/pdf",
  "application/msword",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  "text/plain",
  "text/rtf",
  "application/rtf",
  "application/vnd.ms-excel",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  "text/csv",
  "application/vnd.oasis.opendocument.spreadsheet",
];

export const DOCUMENT_AND_IMAGE_ACCEPT = [
  "image/*",
  ...DOCUMENT_AND_IMAGE_EXTENSIONS,
  ...DOCUMENT_AND_IMAGE_MIME_TYPES,
].join(",");

export const isDocumentOrImageFile = (file) => {
  const name = (file?.name || "").toLowerCase();
  const mimeType = file?.type || file?.originFileObj?.type || "";
  const hasAllowedExtension = DOCUMENT_AND_IMAGE_EXTENSIONS.some((ext) =>
    name.endsWith(ext),
  );

  return (
    hasAllowedExtension ||
    mimeType.startsWith("image/") ||
    DOCUMENT_AND_IMAGE_MIME_TYPES.includes(mimeType)
  );
};

export const beforeUploadDocumentOrImage = (file) => {
  if (!isDocumentOrImageFile(file)) {
    message.error(`${file.name} is not a supported document or image file`);
    return Upload.LIST_IGNORE;
  }

  return false;
};

export const filterDocumentOrImageFileList = (fileList = []) =>
  fileList.filter((file) => isDocumentOrImageFile(file.originFileObj || file));
